import { Box, Icon, Text } from '@ksyos/design-system';
import { OutclinicDashboardStatus } from '@common/enums/outclinicDashboard/outclinicDashboardStatus';
import { translateKey } from '@frontend/translate';

interface IOutclinicDashboardTableStatusIconProps {
    label?: string;
    status: OutclinicDashboardStatus.checked | OutclinicDashboardStatus.warning;
}

export function OutclinicDashboardTableStatusIcon(props: IOutclinicDashboardTableStatusIconProps) {
    const color = props.status === OutclinicDashboardStatus.checked ? 'success' : 'warning';

    return (
        <Box
            alignItems="center"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            textAlign="center"
        >
            <Icon
                color={color}
                icon={props.status}
            />
            {props.label && (
                <Text
                    color={color}
                    fontWeight="medium"
                    size="sm"
                    sx={{
                        mt: 0.5,
                    }}
                    whiteSpace="nowrap"
                >
                    {translateKey(`outclinicDashboard.${props.label}`)}
                </Text>
            )}
        </Box>
    );
}
